import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import MyDashboard from "@/pages/MyDashboard";
import Settings from "@/pages/Settings";
import Install from "@/pages/Install";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/my" element={<MyDashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/install" element={<Install />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
